import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ReferalFormService } from '../shared/referal-form.service';
import { VendorService } from '../shared/vendor.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InstructionsComponent } from '../instructions/instructions.component';
import { StateNames } from '../models/vendor.model';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-non-enumerated-organization-details',
  templateUrl: './non-enumerated-organization-details.component.html',
  styleUrls: ['./non-enumerated-organization-details.component.css','../shared/css/common.css']
})
export class NonEnumeratedOrganizationDetailsComponent implements OnInit {

  nonEnumeratedOrganizationFormData: any;
  formdata : any | null;
  payorkey: number;
  title: string = "Provider";
  isformloaded: boolean = false;
  isInstruction: boolean = false;
  instructionText!: string | null;

  nonEnumeratedOrganizationFormData1: any = {};
  nonEnumeratedOrganizationFormData2: any = {};
  internalInvolvedPartiesKey:number=0;
  isNameRequired:boolean = false;
  isRequiredIdLabelVisible:boolean = false;
  isFormsValid : boolean = false;
  statelist: StateNames[] = [];
  primaryColor?: string = "";
  @Input() inputDetails: any;
  @Output() formValidationEvent: EventEmitter<{isValid:boolean, isChanged: boolean}> = new EventEmitter();

    constructor(
    private providerFormBuilder: FormBuilder, 
    private router: Router,
    private vendorService: VendorService,
    private cdref: ChangeDetectorRef,
    private modalService: NgbModal
  ) 
  { 
    this.payorkey = parseInt(sessionStorage.getItem("payorkey")?? "0");
  }

  nonEnumeratedOrganizationFormPart1 = this.providerFormBuilder.group({});
  nonEnumeratedOrganizationFormPart2= this.providerFormBuilder.group({});


  ngOnInit(): void {
    this.formdata = this.vendorService.getSessionData();
    this.nonEnumeratedOrganizationFormData = this.inputDetails == null ? this.formdata.nonEnumeratedOrganizationDetails : this.inputDetails;
    this.nonEnumeratedOrganizationFormData1["controls"] = this.nonEnumeratedOrganizationFormData.controls.slice(0, 10);
    this.nonEnumeratedOrganizationFormData2["controls"] = this.nonEnumeratedOrganizationFormData.controls.slice(10, 20);
    
    let currentUrl = window.location.hash;
    if(currentUrl.includes('additionalInvolvedParties')) {
      const involvedCtrl = this.formdata.involvedParties.controls.find((x: { name: string; }) => x.name == "additionalInvolvedType");
      this.internalInvolvedPartiesKey = involvedCtrl.value;
      if(involvedCtrl?.value) {
        this.title = involvedCtrl.options.find((y: { value: string }) => y.value == involvedCtrl.value)?.key;
      }
    }
    else {
      const involvedCtrl = this.formdata.witnessDetails.controls.find((x: { name: string }) => x.name == 'involvedType');
      this.internalInvolvedPartiesKey = involvedCtrl.value;
      if(involvedCtrl?.value) {
        this.title = involvedCtrl.options.find((y: { value: string }) => y.value == involvedCtrl.value)?.key;
      }
    }

    this.vendorService.getLeadHeaders(this.payorkey).subscribe((result)=>{          
      this.isInstruction = result.IsInstructionEnbaled;
      let instructionText =  result.Instruction;
      instructionText = instructionText.replace('<img ','<img title="Header" ')
      this.instructionText = instructionText;
    });

    let getStatesApi = this.vendorService.getStateNames();
    let getSubjectRequiredFieldApi = this.vendorService.getSubjectRequiredFieldsByInvolvedParty(this.internalInvolvedPartiesKey, this.payorkey);
    forkJoin([getSubjectRequiredFieldApi, getStatesApi]).subscribe((response: any) => {
      let result = response[0];
      if(result.Name == true)
      {
       this.isNameRequired = true;
      }

      this.nonEnumeratedOrganizationFormData1.controls.find((x: { name: string; }) => x.name == "neoOrgName").validators.required = result.Name;
      this.nonEnumeratedOrganizationFormData1.controls.find((x: { name: string; }) => x.name == "neoTIN").validators.required = result.FederalTIN;
      this.nonEnumeratedOrganizationFormData1.controls.find((x: { name: string; }) => x.name == "neoLicenseNo").validators.required = result.License;
      this.nonEnumeratedOrganizationFormData1.controls.find((x: { name: string; }) => x.name == "neoOther").validators.required = result.Other;
      this.nonEnumeratedOrganizationFormData1.controls.find((x: { name: string; }) => x.name == "neoOtherId").validators.required = result.OtherID;
      this.nonEnumeratedOrganizationFormData1.controls.find((x: { name: string; }) => x.name == "neoContactFirstName").validators.required = result.ContactName;
      
      this.nonEnumeratedOrganizationFormData2.controls.find((x: { name: string; }) => x.name == "neoStreetAddress1").validators.required = result.AddressLine1;
      this.nonEnumeratedOrganizationFormData2.controls.find((x: { name: string; }) => x.name == "neoCity").validators.required = result.City;
      this.nonEnumeratedOrganizationFormData2.controls.find((x: { name: string; }) => x.name == "neoState").validators.required = result.State;
      this.nonEnumeratedOrganizationFormData2.controls.find((x: { name: string; }) => x.name == "neoCounty").validators.required = result.County;
      this.nonEnumeratedOrganizationFormData2.controls.find((x: { name: string; }) => x.name == "neoZip").validators.required = result.ZipCode;
      this.nonEnumeratedOrganizationFormData2.controls.find((x: { name: string; }) => x.name == "neoCountry").validators.required = result.Country;
      this.nonEnumeratedOrganizationFormData2.controls.find((x: { name: string; }) => x.name == "neoPhone").validators.required = result.Phone;
      this.nonEnumeratedOrganizationFormData2.controls.find((x: { name: string; }) => x.name == "neoFax").validators.required = result.Fax;
      this.nonEnumeratedOrganizationFormData2.controls.find((x: { name: string; }) => x.name == "neoEmail").validators.required = result.Email;

      this.isformloaded = true;
      this.statelist = response[1];
      this.nonEnumeratedOrganizationFormData.controls.find((x: { name: string; }) => x.name == "neoState").options = response[1].map((x: any) => { return { "value": x.Abbreviation, "key": x.Name } });
      const countyValue = this.nonEnumeratedOrganizationFormData2.controls.find((x: { name: string; }) => x.name == "neoCounty").value;
      
      setTimeout(() => {
        if (countyValue) {
          (this.nonEnumeratedOrganizationFormPart2.get('neoCounty') as any)?.setValue(countyValue);
        }
      }, 1000);

    });
    setTimeout(() => {
      if (localStorage.getItem('primaryCssColor') != null && typeof (localStorage.getItem('primaryCssColor')) != 'undefined') {
        const colorFromStorage = localStorage.getItem('primaryCssColor');
        this.primaryColor = colorFromStorage ? colorFromStorage.toString() : '';
        document.documentElement.style.setProperty('--primary-color', this.primaryColor);
      }
    }, 0);
    this.nonEnumeratedOrganizationFormPart1.valueChanges.subscribe(() => this.recheckFormValidity());
    this.nonEnumeratedOrganizationFormPart2.valueChanges.subscribe(() => this.recheckFormValidity());
  }
  childInitComplete(){
    this.formValidate(null);
  }

  private recheckFormValidity(): void {
    const allValid =
      this.nonEnumeratedOrganizationFormPart1.valid &&
      this.nonEnumeratedOrganizationFormPart2.valid;

    if (this.isFormsValid !== allValid) {
      this.isFormsValid = allValid;
      this.cdref.detectChanges();
    }

    var tempArr ={
      controls: []
    }
    tempArr.controls = this.nonEnumeratedOrganizationFormData1.controls.concat(this.nonEnumeratedOrganizationFormData2.controls);

    this.formdata.nonEnumeratedOrganizationDetails = tempArr;
    this.vendorService.updateData(this.formdata);
    let isFormChanged = this.nonEnumeratedOrganizationFormPart1.dirty || this.nonEnumeratedOrganizationFormPart2.dirty;
    this.formValidationEvent.emit({isValid: allValid, isChanged: isFormChanged});
  }

  valueChange(data: any) {
    if(data && data.name == 'neoState') {
      this.vendorService.getStateCounties(this.statelist.find( y => y.Id == data.value.target.selectedIndex)?.Abbreviation?? "").subscribe((result)=>{
        this.nonEnumeratedOrganizationFormData.controls.find((x: { name: string; }) => x.name == "neoCounty").options = result.map(x => {return { "value" : x.County, "key" : x.County}});
      })
      this.nonEnumeratedOrganizationFormData.controls.find((x: { name: string; }) => x.name == "neoCounty").disabled = false;
    }
    this.formValidate(data);
    var tempArr ={
      controls: []
    }
    tempArr.controls = this.nonEnumeratedOrganizationFormData1.controls.concat(this.nonEnumeratedOrganizationFormData2.controls);

    this.formdata.nonEnumeratedOrganizationDetails = tempArr;
    this.vendorService.updateData(this.formdata);
  }

  formValidate(data: any) {
    if (this.nonEnumeratedOrganizationFormPart1.valid && this.nonEnumeratedOrganizationFormPart2.valid) {
      this.isFormsValid = true;
    } else {
      this.isFormsValid = false;
    }
  }

  nonEnumeratedOrganizationDetailsSubmit() {
    if (this.nonEnumeratedOrganizationFormPart1.valid && this.nonEnumeratedOrganizationFormPart2.valid) {
      var tempArr ={
        controls: []
      }
      tempArr.controls = this.nonEnumeratedOrganizationFormData1.controls.concat(this.nonEnumeratedOrganizationFormData2.controls);
  
      this.formdata.nonEnumeratedOrganizationDetails = tempArr;
    this.vendorService.updateData(this.formdata);
      this.router.navigate(['validateParticipant']);
    }
  }

  back() {
    var tempArr ={
      controls: []
    }
    tempArr.controls = this.nonEnumeratedOrganizationFormData1.controls.concat(this.nonEnumeratedOrganizationFormData2.controls);

    this.formdata.nonEnumeratedOrganizationDetails = tempArr;
    this.vendorService.updateData(this.formdata);
    this.router.navigate(['involvedParties']);
  }

  openInstruction() {
    const result  = this.modalService.open(InstructionsComponent, {size: 'lg',  ariaLabelledBy: 'Instructions'});
    result.componentInstance.name = this.instructionText;
  }


}